import {
  computed,
  ref,
  toRef,
} from "vue";

export default function PaginationAPI(props, {
  countAllRowsLocal = computed(() => 0),
  isPaginationOutsideLocal = ref(true),
  limitLocal = ref(undefined),
  isLoadingTable = ref(false),
  usePaginationLocal = computed(() => false),
}) {
  const limitsPerPage = toRef(props, "limitsPerPage");
  const loadingTable = toRef(props, "loadingTable");
  const showCount = toRef(props, "showCount");

  const paginationUse = computed(() => {
    if (countAllRowsLocal.value === -1 || loadingTable.value || isLoadingTable.value) {
      return false;
    }
    return usePaginationLocal.value;
  });

  const showCountLocal = computed(() => {
    return !(!showCount.value || countAllRowsLocal.value === -1);
  });

  const pagination = computed(() => {
    return {
      use: paginationUse.value,
      isOutside: isPaginationOutsideLocal.value,
      limitStart: limitLocal.value,
      limitsPerPage: limitsPerPage.value,
    };
  });
  return {
    pagination,
    showCountLocal,
  };
}
